export default __webpack_public_path__ + "static/media/a011-4.d8ee4266.svg";